import React from 'react';
import {
  Box, Typography, Table, TableHead, TableRow, TableCell,
  TableBody, Paper, Chip
} from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

const CompatibilityTable = ({ compatibilities = [] }) => {
  if (!compatibilities.length) return null;

  // Markaya göre grupla
  const grouped = compatibilities.reduce((acc, c) => {
    const brand = c.brandName || 'Diğer';
    if (!acc[brand]) acc[brand] = [];
    acc[brand].push(c);
    return acc;
  }, {});

  return (
    <Box sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <DirectionsCarIcon color="primary" />
        <Typography variant="h6" fontWeight={700}>Araç Uyumluluğu</Typography>
      </Box>
      {Object.entries(grouped).map(([brand, items]) => (
        <Box key={brand} sx={{ mb: 3 }}>
          <Chip label={brand} color="primary" sx={{ mb: 1, fontWeight: 700 }} />
          <Paper variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: 'grey.50' }}>
                  <TableCell><strong>Model</strong></TableCell>
                  <TableCell><strong>Seri / Nesil</strong></TableCell>
                  <TableCell><strong>Yıllar</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map(c => (
                  <TableRow key={c.id || c.vehicleSeriesId} hover>
                    <TableCell>{c.modelName}</TableCell>
                    <TableCell>{c.seriesName}</TableCell>
                    <TableCell>{c.yearStart} – {c.yearEnd ? c.yearEnd : 'günümüz'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </Box>
      ))}
    </Box>
  );
};

export default CompatibilityTable;
